import React from 'react';
import CMSPage from '../../components/CMSPage/CMSPage';

const PrivacyPolicyPage = () => {
  return <CMSPage pageType="privacy-policy" />;
};

export default PrivacyPolicyPage;
